<template>
  <div class="segment-toggle">
    <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="segment-toggle__option"
        :class="{'segment-toggle__option--active': value === option.value}"
        @click="$emit('input', option.value)">
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SegmentToggle',
  props: {
    value: {type: String, required: true},
    options: {type: Array, required: true}, // [{value, label}]
  },
}
</script>

<style scoped>
.segment-toggle {
  display: flex;
  width: 100%;
  margin-bottom: 24px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9e9e9;
  padding: 2px;
}

.segment-toggle__option {
  flex: 1 1 0;
  border: none;
  border-radius: 4px;
  border-left: 1px solid #ddd;
  background-color: #e9e9e9;
  color: #333;
  font-weight: 700;
  padding: 6px;
  cursor: pointer;
}

.segment-toggle__option:first-child {
  border-left: none;
}

.segment-toggle__option--active {
  background-color: #fff;
}
</style>